import Vue from 'vue'

export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

const install = (Vue: any, options: any) => {
  // Vueコンポーネントへ注入
  Object.defineProperty(Vue.prototype, '$delay', {
    get(this: Vue) {
      return delay
    }
  })
  // Vuexストアへ注入
  Object.defineProperty(options.store, '$delay', {
    get(this: any) {
      return delay
    }
  })
}

export default {
  install
}
